import { SVGProps } from 'react';

import { Translations } from './preset';
import { Price } from './price';

export const ADDON_TYPE_DEFAULT = 'default';
export const ADDON_TYPE_DRINKS = 'drinks';
export const ADDON_TYPE_INSURANCE = 'insurance';
export const ADDON_TYPE_TRANSPORT = 'transport';
export const ADDON_TYPE_ACCOMMODATION = 'accommodation';
export const ADDON_TYPE_DONATION = 'donation';
export const ADDON_TYPE_OTHER = 'other';

export const ADDON_CHECKOUT_MODE_FIXED = 'fixed';
export const ADDON_CHECKOUT_MODE_FLEXIBLE = 'flexible';

export type AddonCheckoutMode = typeof ADDON_CHECKOUT_MODE_FIXED | typeof ADDON_CHECKOUT_MODE_FLEXIBLE;

export type AddonModalStepType =
  | typeof ADDON_TYPE_ACCOMMODATION
  | typeof ADDON_TYPE_DEFAULT
  | typeof ADDON_TYPE_DONATION
  | typeof ADDON_TYPE_DRINKS
  | typeof ADDON_TYPE_INSURANCE
  | typeof ADDON_TYPE_OTHER
  | typeof ADDON_TYPE_TRANSPORT;

export type AddonType =
  | typeof ADDON_TYPE_ACCOMMODATION
  | typeof ADDON_TYPE_DONATION
  | typeof ADDON_TYPE_DRINKS
  | typeof ADDON_TYPE_INSURANCE
  | typeof ADDON_TYPE_OTHER
  | typeof ADDON_TYPE_TRANSPORT;

export interface AdmissionTypeArray {
  name: AddonType;
  title: string;
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  className: string;
}

export interface AddonsFormatted {
  [ADDON_TYPE_DRINKS]: Addon[];
  [ADDON_TYPE_INSURANCE]: Addon[];
  [ADDON_TYPE_TRANSPORT]: Addon[];
  [ADDON_TYPE_ACCOMMODATION]: Addon[];
  [ADDON_TYPE_DONATION]: Addon[];
  [ADDON_TYPE_OTHER]: Addon[];
}

interface AddonAdmission {
  id: string;
  name: Translations;
  description: Translations;
  admissionType: 'bottleservice' | 'guestlist' | 'ticket';
}

export interface AddonImage {
  id: string;
  url: string;
  orderPosition: number;
}

export interface Addon {
  id: string;
  admissions: AddonAdmission[];
  soldItems: number;
  companyClubId: string;
  type: AddonType;
  fixedPrice: Price;
  quantity: number | null;
  isRefundable: boolean;
  displayName: string;
  displayDescription: string;
  name: Translations;
  description: Translations;
  itemsIncluded: number;
  vatRate: number | null;
  checkoutMode: AddonCheckoutMode;
  minQuantityPerTicket: number | null;
  maxQuantityPerTicket: number | null;
  // Gallery images sorted by orderPosition (1..N). Defaults to [] for older
  // BE responses pre-B2B-1521.
  images: AddonImage[];
}

export interface AdmissionAddon extends Addon {
  checked: boolean;
}
